import React, { useEffect, useState } from "react";

import styles from "../../../../styles/edit-category-product.module.scss";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Hairline } from "../../../components/Hairline";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";
import { Icon } from "../../../components/core/Icon";

import SetDrinkSizesStep from "./SetDrinkSizesStep";
import SetSizesStep from "./SetSizesStep";
import SetExtraIngredients from "./SetExtraIngredients";
import SetPizzaDoughsStep from "./SetPizzaDoughsStep";
import SetPizzaEdgesStep from "./SetPizzaEdgesStep";
import SetAvailabilityStep from "../SetAvailabilityStep";
import { NumberInput } from "../../../components/NumberInput";
import { CatalogAPI } from "../../../../providers/CatalogAPI";
import { Textarea } from "../../../components/Textarea";
import SelectIconCategory from "./SelectIconCategory";
import { Availability } from "../../../utils/Availability";

const ItemToEdit = {
	settings: "settings",
	sizes: "sizes",
	doughs: "doughs",
	edges: "edges",
	extras: "extras",
	others: "others",
	remove: "remove"
};

const Selector = ({ category, onClick }) => {
	return (
		<>
			<Label>O que você deseja editar?</Label>
			<div className={styles.editOptions}>
				<div onClick={() => onClick(ItemToEdit.settings)}>
					<p>Configurações básicas</p>
					<Icon name="pen" size="sm" />
				</div>
				{category.default_sizes && category.mode != 'step' && category.sizes.length > 1 && (
					<div onClick={() => onClick(ItemToEdit.sizes)}>
						<p>Tamanhos</p>
						<Icon name="pen" size="sm" />
					</div>
				)}
				{category.mode == 'pizza' && (
					<div onClick={() => onClick(ItemToEdit.doughs)}>
						<p>Massa</p>
						<Icon name="pen" size="sm" />
					</div>
				)}
				{category.mode == 'pizza' && (
					<div onClick={() => onClick(ItemToEdit.edges)}>
						<p>Borda</p>
						<Icon name="pen" size="sm" />
					</div>
				)}
				<div onClick={() => onClick(ItemToEdit.extras)}>
					<p>Extra</p>
					<Icon name="pen" size="sm" />
				</div>
				<div onClick={() => onClick(ItemToEdit.others)}>
					<p>Outros</p>
					<Icon name="pen" size="sm" />
				</div>
			</div>
			<div className="d-flex justify-center mt-30">
				<Button design="underline" onClick={() => onClick(ItemToEdit.remove)} >
					Remover esta categoria
				</Button>
			</div>
		</>
	)

}

class EditCategory extends React.Component {

	state = {
		edit: null,
		catalog: {},
		category: {},
		categoryCopy: {},
		removeCategory: false,
		saveLoading: false,
		removeLoading: false,
		disabled: true
	}

	async setStateAsync(data) {
		return await new Promise(resolve => this.setState(data, resolve));
	}

	componentDidMount() {
		const { catalog, category } = this.props;
		this.setState({ catalog, category, categoryCopy: category });
	}

	getHeaderTitle() {
		const { category, removeCategory, edit } = this.state;

		if (removeCategory) return `Remover categoria "${category.name}"`;
		if (!edit) return `Editar categoria - ${category.name}`;

		const EditTitles = {
			settings: "Configurações básicas",
			sizes: "Tamanhos",
			doughs: "Massas",
			edges: "Bordas",
			extras: "Extras",
			others: "Outros",
		};

		return EditTitles[edit];
	}

	onChangeCategory(values) {
		const { category } = this.state;
		this.setState({
			category: { ...category, ...values }
		}, this.validateStep.bind(this));
	}

	validateStep() {
		const { edit, category } = this.state;
		switch (edit) {
			case ItemToEdit.settings:
				return this.setState({ disabled: !category || !category.name });
			case ItemToEdit.sizes:
				return this.setState({
					disabled: category.sizes.reduce((f, size) => (f || (!size.package || !size.unit || !size.amount)), false)
				})
			case ItemToEdit.doughs:
				return this.setState({
					disabled: (
						category.doughs.length > 0
						&& !(category.doughs.reduce((previousDough, dough) => {
							return previousDough && !!dough.name && dough.sizes.reduce((previousDoughSize, doughSize) => {
								return previousDoughSize && !!doughSize.name && !!doughSize.price && Number(String(doughSize.price)) != NaN
							}, true)
						}, true))
					)
				})
			case ItemToEdit.edges:
				return this.setState({
					disabled: (
						category.edges.length > 0
						&& !(category.edges.reduce((previousEdge, edge) => {
							return previousEdge && !!edge.name && edge.sizes.reduce((previousEdgeSize, edgeSize) => {
								return previousEdgeSize && !!edgeSize.name && !!edgeSize.price && Number(String(edgeSize.price)) != NaN
							}, true)
						}, true))
					)
				})
			case ItemToEdit.extras:
				return this.setState({
					disabled: (
						category.extra_ingredients.length > 0
						&& !(category.extra_ingredients.reduce((previousExtra, extra) => {
							return previousExtra && !!extra.name && extra.sizes.reduce((previousExtraSize, extraSize) => {
								return previousExtraSize && !!extraSize.name && !!extraSize.price && Number(String(extraSize.price)) != NaN
							}, true)
						}, true))
					)
				})
			case ItemToEdit.others:
                return this.setState({
                    disabled: Availability.hasIncompleteAvailability(category.availability)
                });
			default:
				return null;
		}
	}

	executeOnSchema(item, callback) {
		for (let field of ['items', 'extra_ingredients', 'edges', 'doughs', 'sizes']) {
			if (item[field] && item[field].length > 0) {
				for (let children of item[field]) {
					const result = callback(children, item, field);
					if (result === false) {
						return;
					}

					this.executeOnSchema(children, callback);
				}
			}
		}
	}

	propagateSizes() {
		const { category } = this.state;
		const { sizes } = category;

		this.executeOnSchema(category, (item) => {
			if (['extraingredient', 'edges', 'step', 'drink', 'pizza', 'doughs'].includes(item.type)) {
				//Adicionar tamanhos
				for (const size of sizes) {
					const itemSizeRefIds = item.sizes.map((s) => s.ref_id)
					if (!itemSizeRefIds.includes(size.ref_id)) {
						item.sizes.push(size);
					}
				}

				//Atualizar tamanhos
				for (const size of sizes) {
					for (const itemSize of item.sizes) {
						if (itemSize.ref_id == size.ref_id) {
							itemSize.name = size.name;
							itemSize.name = size.name;
							itemSize.amount = size.amount;
							itemSize.unit = size.unit;
							itemSize.package = size.package;
							itemSize.max = size.max;
						}
					}
				}

				//Remover tamanhos
				const sizesRefIds = sizes.map((s) => s.ref_id);
				item.sizes = item.sizes.filter((s) => sizesRefIds.includes(s.ref_id));
			}
		})

		return category;
	}

	renderEditContainer() {
		const { edit, category, catalog, removeLoading } = this.state;

		const mountPayload = this.onChangeCategory.bind(this);

		switch (edit) {
			case ItemToEdit.settings:
				return (
					<>
						<SelectIconCategory
							mountPayload={(value) => mountPayload({ image: value })}
							categoryIcon={category.image}
						/>
						<Label>Informe o nome da categoria</Label>
						<Input
							floatLabel="Nome da categoria"
							design="two"
							className="mt-15"
							defaultValue={category.name}
							onChange={(e) => mountPayload({ name: e.target.value })}
						/>
						{/* <Textarea
							id="desc"
							design="two"
							placeholder="Descrição"
							className="mt-20"
							onChange={(e) => mountPayload({ description: e.target.value })}
							defaultValue={category.description}
						/> */}
						{category.mode == 'pizza' && category.sizes.length == 1 && (
							<>
								<Hairline />
								<NumberInput
									floatLabel="Máx. sabores"
									design="two"
									precision={0}
									onChange={(e, m, f) => mountPayload({ sizes: [{ ...category.sizes[0], max: f }] })}
                                    value={category?.sizes[0]?.max || 0}
								/>
							</>
						)}
					</>
				);
			case ItemToEdit.sizes:
				if (["pizza", "step"].includes(category.mode)) {
					return (<SetSizesStep category={category} onChange={mountPayload} />);
				}
				return (<SetDrinkSizesStep category={category} onChange={mountPayload} />);
			case ItemToEdit.edges:
				return (<SetPizzaEdgesStep category={category} onChange={mountPayload} />);
			case ItemToEdit.doughs:
				return (<SetPizzaDoughsStep category={category} onChange={mountPayload} />);
			case ItemToEdit.extras:
				return (<SetExtraIngredients category={category} mountPayload={mountPayload} />);
			case ItemToEdit.others:
				return (<SetAvailabilityStep catalog={catalog} item={category} mountPayload={mountPayload} />);
			case ItemToEdit.remove:
				return (
					<div className={styles.removeCategory}>
						<p>
							Ao excluir a categoria "<strong>{category.name}</strong>",
							você perderá todas as configurações, e produtos cadastrados
							nela. Não sendo possível recuperá-los depois disso.
						</p>
						<Button design="primary" onClick={this.onRemove.bind(this)} className="w-100" disabled={removeLoading} loading={removeLoading}>
							Remover esta categoria
						</Button>
						<Button
							design="default-2"
							className="mt-20 w-100"
							disabled={removeLoading}
							onClick={() => this.setState({ edit: null })}
						>
							Cancelar
						</Button>
					</div>
				)
		}
	}

	async onSave() {
		const { onCategoryUpdated } = this.props;
		const { edit, catalog, category: stateCategory } = this.state;

		await this.setStateAsync({ saveLoading: true });
		const category = (edit == ItemToEdit.sizes) ? this.propagateSizes(stateCategory) : stateCategory;
		this.executeOnSchema(catalog, (item) => {
			if (item.id == category.id && item.type == 'category') {
				for (const prop of Object.keys(category)) {
					item[prop] = category[prop];
				}

				item.availability = Availability.getValidAvailability(item.availability);

				return false;
			}
		});

		const response = await CatalogAPI.putCatalog(catalog, this.props.service);
		this.setState({ edit: null, saveLoading: false });

		onCategoryUpdated && onCategoryUpdated();
	}

	async onRemove() {
		const { onCategoryUpdated, setOpen } = this.props;

		await this.setStateAsync({ removeLoading: true });

		const { catalog, category } = this.state;
		catalog.items = catalog.items.filter((i) => i.id != category.id);

		const response = await CatalogAPI.putCatalog(catalog, this.props.service);
		this.setState({ edit: null, removeLoading: false });

		onCategoryUpdated && onCategoryUpdated();
		setOpen && setOpen(false);
	}

	render() {
		const { open, setOpen } = this.props;
		const { edit, disabled, category, categoryCopy, saveLoading } = this.state;
		const getHeaderTitle = this.getHeaderTitle.bind(this);

		const setEdit = (value) => {
			this.setState({
				edit: value,
				categoryCopy: category,
			}, this.validateStep.bind(this))
		};

		return (
			<Drawer
				visible={open || saveLoading}
				closeInFade={false}
				onClose={(status) => setOpen(false)}
				title={getHeaderTitle()}
				showBackButton={edit}
				backButton={() => this.setState({ edit: null, category: categoryCopy })}
			>
				<div className={styles.scrollContainer}>
					{!edit && (<Selector category={category} onClick={setEdit} />)}
					{this.renderEditContainer()}
				</div>

				{edit && edit != ItemToEdit.remove && (
					<div className={styles.footer}>
						<Button design="primary" onClick={this.onSave.bind(this)} disabled={disabled || saveLoading || category?.availability?.length === 0} loading={saveLoading}>
							Salvar alterações
						</Button>
					</div>
				)}
			</Drawer>
		);
	};
}


export default EditCategory;
